/** @format */
import { css } from 'styled-components';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'product-add-to-quote-link';
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const SKELETON_DEFAULT_TEST_ID = `${DEFAULT_TEST_ID}-skeleton`;

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const TRADE_ARROW_TRANSFORM: Record<
    string,
    Record<'from' | 'to', ReturnType<typeof css>>
> = {
    top: {
        from: css`
            transform: translate(0, -0.25em);
        `,
        to: css`
            transform: translate(1em, -0.25em);
        `,
    },
    topHidden: {
        from: css`
            transform: translate(-1em, -0.25em);
        `,
        to: css`
            transform: translate(0, -0.25em);
        `,
    },
    bottom: {
        from: css`
            transform: translate(0, 0.25em) rotate(180deg);
        `,
        to: css`
            transform: translate(-1em, 0.25em) rotate(180deg);
        `,
    },
    bottomHidden: {
        from: css`
            transform: translate(1em, 0.25em) rotate(180deg);
        `,
        to: css`
            transform: translate(0, 0.25em) rotate(180deg);
        `,
    },
};
